import React from 'react';
import { Announcement, AnnouncementContainer } from 'mintel-react-ui';

import messages from './messages';

export const getMessage = (message: string): Announcement => {
  // Message keys are passed from the backend in the shape: {key}?{arg object}
  const [key, ...args] = message.split('?');

  if (key in messages) {
    // Get the message with the parsed arguments from the key string
    return messages[key](args.length ? JSON.parse(args.join('')) : {});
  }
  return { label: message };
};

/**
 * A component to render Announcements passed from portal backend. Handles
 * specific errors (portal sends keys linking to errors in ./messages.tsx)
 */
export default ({
  errors = [],
  infos = [],
  successMessage = '',
}: {
  errors?: string[];
  infos?: string[];
  successMessage?: string;
}): JSX.Element | null => {
  const constantProps = {
    overflow: true,
    showCloseButton: false,
  };

  const announcements = [
    ...errors.map((err: string) => {
      const error = getMessage(err);
      return {
        ...constantProps,
        mode: 'alert',
        label: error.label,
        key: error.label,
        children: error.message || '',
      };
    }),
    ...infos.map((inf) => {
      const info = getMessage(inf);
      return {
        ...constantProps,
        mode: inf === successMessage ? 'success' : 'info',
        label: info.label,
        key: info.label,
        children: info.message || '',
      };
    }),
  ];

  if (!announcements.length) return null;

  return announcements.length === 1 ? (
    <Announcement {...announcements[0]} {...constantProps} onClose={() => {}} />
  ) : (
    <AnnouncementContainer
      announcements={announcements}
      onClose={() => {
        // do nothing
      }}
      onIgnore={() => {
        // do nothing
      }}
    />
  );
};
